// Email service simulation for WebContainer environment
class EmailService {
  constructor() {
    this.templates = {
      bookingConfirmation: {
        subject: 'Terminbuchung bestätigt',
        template: (booking, slot, calendar) => `
          Hallo ${booking.booker.name},
          
          Ihre Terminbuchung wurde erfolgreich bestätigt:
          
          Termin: ${calendar.title}
          Datum: ${new Date(slot.date).toLocaleDateString('de-DE')}
          Uhrzeit: ${slot.time}
          Dauer: ${slot.duration} Minuten
          
          Buchungs-ID: ${booking.id}
          
          Bei Fragen oder Änderungen können Sie uns gerne kontaktieren.
          
          Mit freundlichen Grüßen
        `
      },
      bookingCancellation: {
        subject: 'Terminbuchung storniert',
        template: (booking) => `
          Hallo ${booking.booker.name},
          
          Ihre Terminbuchung wurde storniert:
          
          Buchungs-ID: ${booking.id}
          Storniert am: ${new Date(booking.cancelledAt).toLocaleDateString('de-DE')}
          
          Mit freundlichen Grüßen
        `
      }
    };
  }

  async sendBookingConfirmation(booking, slot, calendar) {
    // Simulate email sending
    console.log('📧 Sending booking confirmation email:');
    console.log(`To: ${booking.booker.email}`);
    console.log(`Subject: ${this.templates.bookingConfirmation.subject}`);
    console.log(`Body: ${this.templates.bookingConfirmation.template(booking, slot, calendar)}`);
    
    // In a real implementation, this would use a service like:
    // - Nodemailer with SMTP
    // - SendGrid
    // - AWS SES
    // - Postmark
    
    return Promise.resolve({
      success: true,
      messageId: `msg_${Date.now()}`
    });
  }

  async sendBookingCancellation(booking) {
    console.log('📧 Sending booking cancellation email:');
    console.log(`To: ${booking.booker.email}`);
    console.log(`Subject: ${this.templates.bookingCancellation.subject}`);
    console.log(`Body: ${this.templates.bookingCancellation.template(booking)}`);
    
    return Promise.resolve({
      success: true,
      messageId: `msg_${Date.now()}`
    });
  }

  async sendPollInvitation(poll, emails) {
    console.log('📧 Sending poll invitation emails:');
    console.log(`To: ${emails.join(', ')}`);
    console.log(`Subject: Einladung zur Terminumfrage: ${poll.title}`);
    
    return Promise.resolve({
      success: true,
      messageId: `msg_${Date.now()}`
    });
  }

  generateICSFile(booking, slot, calendar) {
    const startDate = new Date(`${slot.date}T${slot.time}`);
    const endDate = new Date(startDate.getTime() + (slot.duration * 60 * 1000));
    
    const formatDate = (date) => {
      return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    };

    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Appointment Booking App//EN
BEGIN:VEVENT
UID:${booking.id}@appointmentapp.com
DTSTART:${formatDate(startDate)}
DTEND:${formatDate(endDate)}
SUMMARY:${calendar.title}
DESCRIPTION:Buchung über Terminbuchungs-App\\nBuchungs-ID: ${booking.id}
STATUS:CONFIRMED
END:VEVENT
END:VCALENDAR`;

    return icsContent;
  }
}

export const emailService = new EmailService();